module.exports = __webpack_public_path__ + "img/message.1b594a7b.svg";